module.exports = __webpack_public_path__ + "img/main_menu_4.1029c62a.png";